import React from 'react';
import { __ } from 'first-intl';
import { TRACK_ID } from '@hugendubel/tracking_client';
import { ArticleBox } from '../articles/ArticleBox';
import { A, Button } from '@hugendubel/react-basic';
import { AppRoutes } from '../../appRoutes';
import { WsBonusShopOrder } from '../../../ws/result/WsBonusShopOrder';
import { Globals } from '../../../globals';
import { BonusPointsDetails } from '../bonus/BonusPointsDetails';

const _OrderConfirmationScreenLayout = {
    onPrint: () => {
        Globals.window().print();
    },
};

export type OrderConfirmationScreenLayoutProps = { lastOrder: WsBonusShopOrder };

export const OrderConfirmationScreenLayout: React.FC<OrderConfirmationScreenLayoutProps> = ({ lastOrder }) => (
    <div className="hidden-print">
        <div className="container-fluid">
            <div className="row">
                <div className="col-sm-8">
                    <h1>{__('page.Confirmation.title')}</h1>
                </div>
            </div>
            <div className="row">
                <div className="col-sm-4 col-sm-push-8 align-right">
                    <BonusPointsDetails />
                </div>
                <div className="col-sm-8 col-sm-pull-4">
                    <div className="bonus-item readOnly">
                        <ArticleBox article={lastOrder.article} showPrice={false} />
                    </div>
                </div>
            </div>
            <div className="buttons">
                <A trackId={TRACK_ID('2019-07-31 04:15:13')} className="btn btn-default btn-lg" href={AppRoutes.HOME}>
                    {__('page.Confirmation.button.continue')}
                </A>
                <Button
                    className="btn btn-primary btn-lg"
                    label="page.Confirmation.button.print"
                    type="button"
                    onClick={_OrderConfirmationScreenLayout.onPrint}
                />
            </div>
        </div>
    </div>
);
